/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ActivitycategoriesQueryResponse } from '../../types/GetV1Activitycategories.ts'

export const getV1ActivitycategoriesQueryKey = () => [{ url: '/v1/ActivityCategories' }] as const

export type GetV1ActivitycategoriesQueryKey = ReturnType<typeof getV1ActivitycategoriesQueryKey>

/**
 * {@link /v1/ActivityCategories}
 */
export async function getV1Activitycategories(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ActivitycategoriesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ActivityCategories`, ...requestConfig })
    return res
}

export function getV1ActivitycategoriesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ActivitycategoriesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ActivitycategoriesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ActivitycategoriesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Activitycategories(config)
        },
    })
}

/**
 * {@link /v1/ActivityCategories}
 */
export function useGetV1Activitycategories<
    TData = ResponseConfig<GetV1ActivitycategoriesQueryResponse>,
    TQueryData = ResponseConfig<GetV1ActivitycategoriesQueryResponse>,
    TQueryKey extends QueryKey = GetV1ActivitycategoriesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ActivitycategoriesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ActivitycategoriesQueryKey()

    const query = useQuery(
        {
            ...getV1ActivitycategoriesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
